import {
  CATALOG_AUTHOR_CITATIONS_RESET_DATA,
  CATALOG_AUTHOR_CITATIONS_SET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  author: null,
  citations: null,
  pageNumber: 1,
  lastPageNumber: 0,
};

export default function authorCitationList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_AUTHOR_CITATIONS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_AUTHOR_CITATIONS_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
